import URI from "urijs";
export default (destUrl, page, perPage, query, additional = {}) => {
  let uri = new URI(destUrl).addSearch("page", page).addSearch("per_page", perPage);
  if (additional) {
    Object.keys(additional).forEach((field) => {
      const value = additional[field];
      const processValue = (val) => typeof val.toString === "function" ? val.toString() : val;
      if (value === void 0) {
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((arrayValue) => {
          uri = uri.addSearch(field, processValue(arrayValue));
        });
        return;
      }
      uri = uri.addSearch(field, processValue(value));
    });
  }
  if (query) {
    uri.addSearch("query", query);
  }
  return uri.toString();
};
